import data from './data/banlist.json';

export type BanStatus = 'forbidden' | 'limit1' | 'limit2' | 'limit3';

const map = data.status as Record<string, BanStatus>;

export const BANLIST_NAME = data.list;

/** Per-list deck-wide maximum (total cards from that whole list). */
export const BAN_LIMIT: Record<'limit1' | 'limit2' | 'limit3', number> = { limit1: 1, limit2: 2, limit3: 3 };

/** Banlist status for a card (by our-catalog name), or null if unrestricted. */
export function banStatus(name: string): BanStatus | null {
  return map[name] ?? null;
}

/** All banlist cards grouped by status, each sorted alphabetically. */
export function banlistGroups(): Record<BanStatus, string[]> {
  const g: Record<BanStatus, string[]> = { forbidden: [], limit1: [], limit2: [], limit3: [] };
  for (const [name, st] of Object.entries(map)) g[st].push(name);
  (Object.keys(g) as BanStatus[]).forEach(k => g[k].sort((a, b) => a.localeCompare(b)));
  return g;
}

/** Small badge shown on a card: symbol + css class. */
export const BAN_BADGE: Record<BanStatus, { symbol: string; cls: string; title: string }> = {
  forbidden: { symbol: '⊘', cls: 'ban-forbidden', title: 'Forbidden' },
  limit1: { symbol: '1', cls: 'ban-1', title: 'Limit 1 list' },
  limit2: { symbol: '2', cls: 'ban-2', title: 'Limit 2 list' },
  limit3: { symbol: '3', cls: 'ban-3', title: 'Limit 3 list' },
};
